import shortid from "shortid"
import seedrandom from "seedrandom"
import querystring from "query-string"

import Dev from "@frog/source/models/admin/Dev.js"

const query = querystring.parse(window.location.search)
const seed = query.seed || shortid.generate()
seedrandom(seed, {"global": true})
if(Dev.isEnabled) {
    const url = window.location.origin + (window.location.path || "") + "?seed=" + seed
    console.info("%cRandom: To maintain your random seed, go to " + url, "color: green")
}

export default class Random {
    static sign() {
        return Math.random() < 0.5 ? -1 : +1
    }
    static range(a, b) {
        const min = Math.min(a, b)
        const max = Math.max(a, b)
        return min + (Math.random() * (max - min))
    }
    static element(array) {
        return array[Math.floor(Math.random() * array.length)]
    }
    static shuffle(array) {
        const superarray = array.slice()
        for(let i = superarray.length - 1; i > 0; i -= 1) {
            let j = Math.floor(Math.random() * (i + 1))
            let temp = superarray[i]
            superarray[i] = superarray[j]
            superarray[j] = temp
        }
        return superarray
    }
}
